module.exports = __webpack_public_path__ + "img/ctrl-stub--i.769ab03f.svg";